
import { mapState } from "vuex";

import { PRODUCT_PAGE_QUERY, PAGE_TYPE } from "./-facet.query";
import {
  seoMixin,
  pageMixin,
  itemListSchemaMixin,
  faqSchemaMixin,
} from "~/mixins";

const createUID = params => {
  const facet = params.facet?.replace(/\s/g, "-").toLowerCase() ?? "";

  const facetValue = params.facetValue?.replace(/\s/g, "-").toLowerCase() ?? "";

  return `${params.handle}__${facet}__${facetValue}`;
};

export default {
  mixins: [seoMixin, pageMixin, itemListSchemaMixin, faqSchemaMixin],

  async asyncData({ app, params, error }) {
    const uid = createUID(params);

    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: PRODUCT_PAGE_QUERY,
      variables: { uid, lazy: false },
    });

    if (data?.collection == null || (data?.slices ?? []).length == 0) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const plpBanner = data.plp_banner_link;
    const bannerConfig = plpBanner?.display_banners
      ? {
          productTileBanners: [
            { image: plpBanner.image_1, image_link: plpBanner.image_1_link },
            { image: plpBanner.image_2, image_link: plpBanner.image_2_link },
          ].filter(({ image }) => image),
          heroBanner: {
            image: plpBanner.image,
            image_link: plpBanner.image_link,
          },
        }
      : null;

    return {
      uid,
      title: data.title,
      slices: data.slices,
      metaTitle: data.metaTitle,
      pageType: PAGE_TYPE,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      context: { collection: data.collection, bannerConfig },
    };
  },

  computed: {
    ...mapState("app", ["isFilterPanelOpen"]),

    additionalScripts() {
      const itemList = this.itemListSchemaScript
        ? [this.itemListSchemaScript]
        : [];
      return [...itemList, ...this.faqSchemaScripts].filter(Boolean);
    },
  },

  beforeDestroy() {
    this.$store.dispatch("app/CLOSE_FILTER_PANEL");
  },
};
